import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'

import WarningPopup from '@/components/main/WarningPopup.vue'
import ThemeToggle from '@/components/main/ThemeToggle.vue'
import MainHeader from '@/components/main/MainHeader.vue'
import CommunityLinks from '@/components/main/CommunityLinks.vue'
import CalendarView from '@/components/main/CalendarView.vue'
import NoticeBoard from '@/components/main/NoticeBoard.vue'
import YoutubeRankingSlider from '@/components/main/YoutubeRankingSlider.vue'
import MemberGallery from '@/components/main/MemberGallery.vue'
import FixedButtons from '@/components/main/FixedButtons.vue'
import FooterBar from '@/components/main/FooterBar.vue'
import CheckToday from '@/components/main/CheckToday.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'MainPage',
  setup(__props) {

const isDark = ref(false)
const selectedMember = ref<any>(null)

function toggleTheme() {
  isDark.value = !isDark.value
}

function onSelectMember(member: any) {
  selectedMember.value = member
}

function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

return (_ctx: any,_cache: any) => {
  const _component_ProfileDetailModal = _resolveComponent("ProfileDetailModal")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['mainbody', { 'dark-mode': isDark.value }])
  }, [
    _createVNode(WarningPopup),
    _createVNode(MainHeader, { "is-dark": isDark.value }, null, 8, ["is-dark"]),
    _createVNode(ThemeToggle, {
      "is-dark": isDark.value,
      onToggle: toggleTheme
    }, null, 8, ["is-dark"]),
    _createVNode(CommunityLinks),
    _createVNode(CalendarView, { "is-dark": isDark.value }, null, 8, ["is-dark"]),
    _createVNode(NoticeBoard),
    _cache[1] || (_cache[1] = _createElementVNode("hr", { class: "section-divider" }, null, -1)),
    _createVNode(YoutubeRankingSlider),
    _cache[2] || (_cache[2] = _createElementVNode("h1", { style: {"font-size":"20px","margin-bottom":"20px"} }, [
      _createElementVNode("a", {
        style: {"text-decoration":"none"},
        href: "/youtubeVideo"
      }, "피프티 최신영상 보러가기")
    ], -1)),
    _cache[3] || (_cache[3] = _createElementVNode("hr", { class: "section-divider" }, null, -1)),
    _createVNode(MemberGallery, { onSelect: onSelectMember }),
    (selectedMember.value)
      ? (_openBlock(), _createBlock(_component_ProfileDetailModal, {
          key: 0,
          member: selectedMember.value,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (selectedMember.value = null))
        }, null, 8, ["member"]))
      : _createCommentVNode("", true),
    _createVNode(FixedButtons, { onTop: scrollToTop }),
    _createVNode(FooterBar),
    _createVNode(CheckToday)
  ], 2))
}
}

})